import React, { useMemo } from "react";
import cx from "classnames";
import { useTranslate } from "hooks";
import { Checkbox, Spinner } from "components";
import { topologyConfig } from "components/Topology/configs/topologyConfig";
import {
  useIsFetching,
  useSelectedPasteItem,
  useWizardActions,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";

export const PastConfigButton = React.memo(
  ({ topologyParentId, title, presentation }) => {
    const translate = useTranslate();
    const isActionFetching = useIsFetching();
    const selectedPasteItem = useSelectedPasteItem();
    const { handlePasteAction } = useWizardActions();

    const { nodeWidth, nodeHeight } = topologyConfig;

    const isChecked = useMemo(
      () => selectedPasteItem?.has(topologyParentId),
      [selectedPasteItem, topologyParentId],
    );

    const selectText = useMemo(
      () =>
        isChecked
          ? translate("WIZARD_NODE_SELECTED")
          : translate("WIZARD_NODE_SELECT"),
      [isChecked, translate],
    );

    return (
      <div
        className="d-flex align-items-center cursor-pointer overflow-hidden justify-content-between"
        data-test-parentid={`pastConfigBtn-${topologyParentId}`}
        style={{
          height: nodeHeight,
          width: nodeWidth,
          maxWidth: nodeWidth,
          paddingLeft: nodeHeight,
          transform: "translateY(50%)",
        }}
        onClick={() => handlePasteAction(topologyParentId)}
      >
        <div className="ms-3 d-flex flex-column flex-1" style={{ minWidth: 0 }}>
          <span className="d-block font16 font-bold lh-1 text-gray-700 text-truncate">
            {title}
          </span>
          <span className="font14 lh-1 text-warning">{presentation}</span>
        </div>
        <div className="flex-shrink-1 d-flex align-items-center ps-1">
          <div
            className={cx(
              "p-2 rounded-2 bg-blue-300 font16 fw-bold text-white text-nowrap",
            )}
          >
            {selectText}
          </div>
          <div className="px-2_5">
            {isActionFetching && isChecked ? (
              <Spinner size="xs" classNames="text-white" />
            ) : (
              <Checkbox
                checked={isChecked}
                classNames="border border-gray-700 bg-gray-300"
                classNamesIcon={"text-gray-700"}
                readOnly
                data-test-toplogyparentid={topologyParentId}
                data-testid={`checkbox-${topologyParentId}`}
              />
            )}
          </div>
        </div>
      </div>
    );
  },
);
